import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray } from '@angular/forms';
import { CommissioningStatusEnum } from '@bo-client/activation-management/shared/models/commissioningModel';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ToastrService } from 'ngx-toastr';
import { UploadDocumentService } from '@bo-client/shared/components/upload-documents/upload-document.service';
import { CompareEnum } from '@bo-client/shared/constants/enums';
import { UploadTypeEnum } from '@bo-client/shared/components/upload-documents/upload-documents.enum';

@Component({
  selector: 'app-upload-documents',
  templateUrl: './upload-documents.component.html',
  styleUrls: ['./upload-documents.component.scss']
})
export class UploadDocumentsComponent implements OnInit {
  @Input() inputFormArray: FormArray;
  @Input() numberOfUploads: number;
  @Input() editUpload: boolean;
  @Input() showUploadButton = false;
  @Input() showTag = true;
  @Input() documentTag = '';
  @Input() filterCriteria: string = null;
  @Input() canUpdate = false;
  @Output() uploaded: EventEmitter<UploadTypeEnum> = new EventEmitter<UploadTypeEnum>();
  @Input() validFormats: string[] = ['.pdf', '.png', '.jpg', '.jpeg'];

  public commissioningStatusEnum = CommissioningStatusEnum;
  public numberShownElements = 0;

  isAllDataLoaded = false;

  constructor(
    private httpHapService: HttpHapService,
    private toastService: ToastrService,
    private uploadDocumentService: UploadDocumentService
  ) {}

  ngOnInit(): void {
    this.countElementsToShow();
  }

  savedDoc($event, indexArray: number) {
    if (this.showUploadButton) {
      this.enableForm();
    }
    if ($event.saved) {
      if (indexArray) {
        (this.inputFormArray as FormArray).controls[indexArray].patchValue($event.documentDto);
      } else {
        this.inputFormArray.push(this.uploadDocumentService.createDocumentUploadForm($event.documentDto));
      }
      this.inputFormArray.markAsTouched();
      this.toastService.success('Datei gespeichert');
      let uploadType: UploadTypeEnum = UploadTypeEnum.upload;
      if (this.showUploadButton) {
        uploadType = UploadTypeEnum.uploadAfterDisable;
      }
      this.uploaded.emit(uploadType);
      this.countElementsToShow();
    } else {
      this.toastService.error($event.errorMessage);
      this.isAllDataLoaded = false;
    }
  }

  showItem(indexArray: number) {
    if (!this.filterCriteria) return true;
    const tag = (this.inputFormArray as FormArray).controls[indexArray].get('tag').value;
    return this.filterCriteria == CompareEnum.equal ? this.documentTag == tag : this.documentTag != tag;
  }

  delete(indexArray: number) {
    this.inputFormArray.removeAt(indexArray);
    this.inputFormArray.markAsTouched();
    this.countElementsToShow();
  }

  countElementsToShow() {
    this.numberShownElements = (this.inputFormArray as FormArray).value.filter(
      (ele) =>
        (this.filterCriteria == CompareEnum.equal && this.documentTag == ele.tag) ||
        (this.filterCriteria == CompareEnum.notEqual && this.documentTag != ele.tag) ||
        !this.filterCriteria
    ).length;
  }

  disableForm() {
    Object.keys(this.inputFormArray.controls).forEach((controlName) => {
      this.inputFormArray.controls[controlName]['disable']();
    });
  }

  enableForm() {
    Object.keys(this.inputFormArray.controls).forEach((controlName) => {
      this.inputFormArray.controls[controlName]['enable']();
    });
  }
}
